import * as actions from "@p81-common/shell-core-js/dist/redux/addressesGet";

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [actions.ADDRESSES_GET_REQUEST]: (state, action) => ({
    ...state,
    loading: true,
    loaded: false,
    error: null,
    data: state.data,
    params: action.params,
  }),
  [actions.ADDRESSES_GET_REQUEST_SUCCESS]: (state, action) => ({
    ...state,
    loading: false,
    loaded: true,
    error: null,
    data: action.data,
    params: action.params,
  }),
  [actions.ADDRESSES_GET_REQUEST_FAILURE]: (state, action) => ({
    ...state,
    loading: false,
    loaded: false,
    error: action.error,
    data: null,
    params: action.params,
  }),
  [actions.ADDRESSES_GET_RESET]: (state, action) => initialState,
};

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {
  loaded: false,
  loading: false,
  error: null,
  data: null,
};

export default function addressesGetReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
